import toast from 'react-hot-toast'

const Notify = (type: any, message: string, autoClose: number = 1000) => {
    toast.dismiss()
    const obj: any = {
        position: 'top-right',
        //duration: autoClose,
    }
    if (type == 'success') {
        toast.success(message, obj)
    } else if (type == 'error') {
        toast.error(message, obj)
    }
}

export default Notify
